<template>
    <div>
      <scenic-spot :value.sync="scenicSpot"/>
      <h3>专用码(核销计数)</h3>
      <q-r-code :value="miniProgramLink"/>
      <h3>通用码(匿名核销)</h3>
      <q-r-code value="https://cloud.sea-high.com/api/mini_program/?check_vip=1"/>
    </div>
</template>
<script>
import {onMounted, reactive, computed} from 'vue'
import ScenicSpot from './ScenicSpot'
import axios from '../../../request'
import {useRoute} from 'vue-router'
import QRCode from '../../../components/QRCode'

export default {
  components: {QRCode, ScenicSpot},
  setup() {
    const scenicSpot = reactive({
      location: '',
      name: '',
      pictures: [],
      description: '',
      division: [],
      divisionDetail: '',
      isHot: false,
      needBooking: false,
      maxBookingCount: 5
    })

    const route = useRoute()

    onMounted(async () => {
      const res = await axios.get(`/scenic_spots/${route.params.id}`)
      scenicSpot.id = res.id
      scenicSpot.name = res.name
      scenicSpot.pictures = res.pictures
      scenicSpot.description = res.description
      scenicSpot.division = res.division.split(',')
      scenicSpot.divisionDetail = res.divisionDetail
      scenicSpot.location = res.location
      scenicSpot.isHot = res.isHot
      scenicSpot.needBooking = res.needBooking
      scenicSpot.maxBookingCount = res.maxBookingCount || 5

      const bookings = await axios.get('/bookings', {
        params: {
          target_type: 'ScenicSpot',
          target_id: res.id,
        }
      })

      console.log(bookings)
    })

    const miniProgramLink = computed(()=>{
      return `https://cloud.sea-high.com/api/mini_program/?check_vip=1&id=${scenicSpot.id}&type=ScenicSpot`
    })


    return {
      scenicSpot,
      miniProgramLink
    }
  }
}
</script>
